import { ANIMATION_SPEED } from '@/settings';
import { css } from 'lit';

export const fileUploadStyles = css`
  .file-upload-container {
    height: 170px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 5px;
  }
  .upload-area,
  .drop-area {
    background: #ffffff;
    min-height: 200px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-radius: var(
      --fg-borderradius--xs,
      var(--fg-fallback-borderradius--xs)
    );
    position: relative;
    transition:
      border ease-in-out ${ANIMATION_SPEED}s,
      background-color ease-in-out ${ANIMATION_SPEED}s;
    padding: 24px 32px;
  }
  .upload-area.green {
    background-color: var(
      --fg-success--light,
      var(--fg-fallback-success--light)
    );
    border: 1px solid var(--fg-success, var(--fg-fallback-success));
  }
  .drop-area {
    background-color: #ffffff;
    border: 1px dashed var(--fg-gray--300, var(--fg-fallback-gray--300));
    border-radius: var(
      --fg-borderradius--sm,
      var(--fg-fallback-borderradius--sm)
    );
  }
  .drop-area.active {
    border: 2px dashed var(--fg-cta, var(--fg-fallback-cta));
    background-color: var(
      --fg-primary--light,
      var(--fg-fallback-primary--light)
    );
  }

  .drop-title {
    align-items: center;
    color: var(--fg-gray--800, var(--fg-fallback-gray--800));
    font-size: 18px;
    font-weight: 600;
    display: flex;
    justify-content: center;
    padding: 8px 0 28px 0;
  }

  .drop-title svg {
    margin-right: 8px;
  }

  label.button,
  .button.upload {
    display: flex;
    align-items: center;
    cursor: pointer;
    margin-top: 10px;
    border: none;
    padding: 0 40px;
  }

  input[type='file'] {
    display: none;
  }
`;
